import { Check } from 'lucide-react';
import { Checkbox as RadixCheckbox } from 'radix-ui';
import { type ReactNode, useId } from 'react';
import { cn } from '../lib/cn';

export function Checkbox({
  checked,
  onCheckedChange,
  label,
  id: idProp,
  disabled,
  className,
  touchTarget = false,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label?: ReactNode;
  id?: string;
  disabled?: boolean;
  className?: string;
  /**
   * Większy cel dotyku (36 × 36 px) bez zmiany wyglądu: przezroczysty obszar wokół pola, np. w wierszach checklisty
   * bez widocznej etykiety (16 px to za mało na telefonie).
   */
  touchTarget?: boolean;
}) {
  const autoId = useId();
  const id = idProp ?? `cb${autoId}`;
  return (
    <div className={cn('inline-flex items-center gap-2', className)}>
      <RadixCheckbox.Root
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        className={cn(
          'inline-flex size-4 shrink-0 items-center justify-center rounded-xs border-[1.5px] border-line-strong bg-canvas',
          touchTarget && 'relative before:absolute before:-inset-3',
          'transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
          'data-[state=checked]:border-accent data-[state=checked]:bg-accent data-[state=checked]:text-on-accent',
          'disabled:opacity-50',
        )}
      >
        <RadixCheckbox.Indicator>
          <Check size={12} strokeWidth={2.5} aria-hidden />
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      {label && (
        <label htmlFor={id} className="cursor-pointer text-body-s text-fg-secondary select-none">
          {label}
        </label>
      )}
    </div>
  );
}
